import axios from 'axios';
import toast from 'react-hot-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/v2`;

export async function startProUpgrade() {
  try {
    const token = localStorage.getItem('systemklart_token');
    const response = await axios.post(`${API}/stripe/checkout`, {
      package_id: 'pro_monthly',
      origin_url: window.location.origin,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    });

    if (response.data.checkout_url) {
      window.location.href = response.data.checkout_url;
    } else {
      toast.error('Kunne ikke starte betalingsprosessen');
    }
  } catch (error) {
    const msg = error.response?.data?.detail || 'Feil ved oppgradering. Prøv igjen.';
    toast.error(msg);
  }
}
